

import { getActiveDirectoryConfig } from './env';

 const getAzureCredentials = () => {
     const clientId = getActiveDirectoryConfig().clientId;
     const authorityKey = `57952406-af28-43c8-b4de-a4e06f57476d`;
     return { clientId, authorityKey };
 };

export const msalConfig = {
    auth: {
        navigateToLoginRequestUrl: false,
        clientId: getAzureCredentials().clientId,
        authority: `https://login.microsoftonline.com/${getAzureCredentials().authorityKey}`,
        redirectUri: getActiveDirectoryConfig().redirectUri
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {	
        loggerOptions: {	
            // MSAL logging is intentionally disabled; nothing is emitted for any level.
            loggerCallback: () => undefined	
        }	
    },
    
};

export const loginRequest = {
    scopes: [getActiveDirectoryConfig().scope, "User.Read", "offline_access"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};